import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

export default function CustomHoldFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const [noteError, setNoteError] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-hold"
        label="Hold"
        variant="contained"
        size="medium"
        sx={{
          marginLeft: "10px",
          width: "120px",
          color: "#e9fce7",
          bgcolor: "#75899d",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-hold"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const notes = formJson.notes;
            if (notes == "" || notes == null || notes == undefined) {
              setNoteError(true);
              return false;
            }
            const reqUrl = `applications/actions/recommend/hold`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });

            if (response && response.status == "200") {
              successNotify("Data saved successfully");
              if (props.cb) {
                props.cb("Hold");
              }
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Hold" />
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            Add Note (Max 150 Characters)
            <span className="requiredLabel">*</span>
          </DialogContentText>
          <TextField
            id="notes"
            name="notes"
            placeholder="Notes"
            multiline={true}
            minRows={1}
            fullWidth
            variant="outlined"
            error={noteError}
            helperText={noteError ? "Notes is required" : ""}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit
            label="Hold"
            sx={{
              marginLeft: "10px",
              width: "120px",
              color: "#e9fce7",
              bgcolor: "#75899d",
              "&:hover": { bgcolor: "gray" },
            }}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
